import { API_ENDPOINTS } from "@/config/app";

import { apiClient } from "../client";
import type {
  IAdminAssignRoles,
  OptionItem,
  OptionsResponse,
  OptionType,
} from "./types";

export const adminApi = {
  async getOptions(types: OptionType | OptionType[]): Promise<OptionsResponse> {
    const typesArray = Array.isArray(types) ? types : [types];
    const query = typesArray.map(t => `types=${t}`).join("&");

    const response = await apiClient.get<OptionsResponse>(
      `${API_ENDPOINTS.ADMIN}/options?${query}`
    );
    return response;
  },

  async getCityByCountry(countryCode: string): Promise<OptionItem[]> {
    const response = await apiClient.get<OptionItem[]>(
      `${API_ENDPOINTS.ADMIN}/options/cities-by-country?countryCode=${countryCode}`
    );
    return response;
  },

  async getAdminRolesAssignments(): Promise<IAdminAssignRoles> {
    const response = await apiClient.get<IAdminAssignRoles>(
      `${API_ENDPOINTS.ADMIN}/options/permissions`
    );
    return response;
  },
};
